import axios from "axios"

const axiosAuthInstance2 = axios.create({
  baseURL: process.env.REACT_APP_EZDAN,
  Accept: "application/json",
  "Content-Type": "application/json",
})



axiosAuthInstance2.interceptors.request.use(
  config => {
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default axiosAuthInstance2
